<div class="dialog">
  <div class="dialog-header">
    <h4 mat-dialog-title>
      <mat-icon>directions_boat</mat-icon>
      {{ 'dredging_fuel_title' | translate }}
    </h4>
  </div>

  <form #form="ngForm">
    <div class="form-content">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'dredging_fuel_label_name' | translate }}</mat-label>
        <input matInput [placeholder]="'dredging_fuel_placeholder_name' | translate" [(ngModel)]="displayName" name="displayName" required cdkFocusInitial />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'dredging_fuel_label_code' | translate }}</mat-label>
        <input matInput [placeholder]="'dredging_fuel_placeholder_code' | translate" [(ngModel)]="code" name="code" required />
      </mat-form-field>
    </div>
  </form>

  <div mat-dialog-actions>
    <button mat-button (click)="onCancel()" [disabled]="isSubmitting">{{ 'dredging_fuel_btn_cancel' | translate }}</button>
    <button mat-raised-button color="accent" (click)="onSubmit()" [disabled]="!form.valid || isSubmitting">
      <mat-icon *ngIf="isSubmitting">sync</mat-icon>
      <span *ngIf="!isSubmitting">{{ 'dredging_fuel_btn_create' | translate }}</span>
      <span *ngIf="isSubmitting">{{ 'dredging_fuel_btn_creating' | translate }}</span>
    </button>
  </div>
</div>
